<template>
    <div>
        <h2 class="primary--text">{{ title }}</h2>
        <v-chip-group
            v-if="title === 'Activity'"
            :value="value"
            :key="value.length === 0 ? 'empty' : value.join(',')"
            multiple
            class="d-flex flex-wrap align-center"
            @change="onFilterChange"
        >
            <v-chip
                v-for="filter in availableFilters"
                :key="filter.name"
                :value="filter.name"
                filter
                outlined
                class="ma-1"
            >
                {{ filter.name }}
            </v-chip>
        </v-chip-group>
        <v-divider class="primary"></v-divider>
        <div class="ma-2"></div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    data: () => ({
        availableFilters: [
            { name: 'AutoDiagJob' },
            { name: 'GetReportJob' },
            { name: 'SetOrGetParamJob' },
            { name: 'AppUpdateJob' },
            { name: 'NoSleepJob' },
            { name: 'GetDiagJob' },
            { name: 'SetOrGetPropertiesJob' }
        ]
    }),

    props: {
        title: String,
        value: { type: Array, default: () => [] }
    },
    watch: {
        value(newVal) {
            console.log('[TitleContainerComponent] reçoit value:', newVal);
        }
    },
    methods: {
        onFilterChange(filters) {
            this.$emit('input', filters);
            this.$emit("filterJobs", filters)
        }
    }
}
</script>